(function () {
  // Render the existing theme data without a billable Places request per page.
  const curatedGoogleReviews = [
    {
      authorAttribution: {
        displayName: 'Jacques M',
        uri: 'https://www.google.com/maps/contrib/116825471374497415854/reviews?hl=fr',
        photoURI:
          'https://lh3.googleusercontent.com/a/ACg8ocLqOy47MGZlI5uzppKwoXZnFUxcy1Bip45mL0tKJI6xxdB-Ww=w36-h36-p-rp-mo-br100',
      },
      publishMonth: '2026-09',
      rating: 5,
      text: 'Je recommande +++++ cette entreprise,qui du début jusqu’à la Fin, a été très professionnelle et très commerçant et avec une livraison rapide. Merci à Rémi, rien à dire,tout est parfait',
    },
    {
      authorAttribution: {
        displayName: 'Noé',
        uri: 'https://www.google.com/maps/contrib/115360133641636731260/reviews?hl=fr',
        photoURI:
          'https://lh3.googleusercontent.com/a-/ALV-UjVkQNZkhlo6cBDiNf0BVpifFYdALWJRhbgtCZaKRiG6GaV4l2nK=w36-h36-p-rp-mo-br100',
      },
      publishMonth: '2026-08',
      rating: 5,
      text: 'Entreprise hyper réactive pour mon projet professionnel.\nJ’ai demandé un contenaire 20 Pouces occasion, il est arrivé étanche avec le certificat dit CSC.\nLivraison en 1 semaine sur mon site.\n\nJe recommande vivement\nCdt',
    },
    {
      authorAttribution: {
        displayName: 'Mat G',
        uri: 'https://www.google.com/maps/contrib/106307064049446669523/reviews?hl=fr',
        photoURI:
          'https://lh3.googleusercontent.com/a/ACg8ocLcSR299l8zTKkxAFHYMepa18_j78KliE43BebhueDkkYy-4Q=w36-h36-p-rp-mo-br100',
      },
      publishMonth: '2026-08',
      rating: 5,
      text: 'Une entreprise sérieuse et professionnelle qui m’a accompagné tout au long de mon projet de stockage pour mon entreprise. L’équipe a toujours été disponible, à l’écoute et réactive, avec des conseils de qualité à chaque étape. Les délais ont été respectés et le conteneur correspond parfaitement à mes attentes. Je recommande cette entreprise sans hésitation pour son professionnalisme et la qualité de son service.',
    },
    {
      authorAttribution: {
        displayName: 'Pa A',
        uri: 'https://www.google.com/maps/contrib/112129587710506046933/reviews?hl=fr',
        photoURI:
          'https://lh3.googleusercontent.com/a/ACg8ocLdBXEGkH9AGR0nhbRrWN6fG4lusAk27q_MTeCNbSWfPLQYYQ=w36-h36-p-rp-mo-ba12-br100',
      },
      isLocalGuide: true,
      publishMonth: '2026-08',
      rating: 5,
      text: 'Super conteneur livré sur Grenoble. Merci aux équipes pour leur accompagnement et professionnel',
    },
    {
      authorAttribution: {
        displayName: 'ted macted',
        uri: 'https://www.google.com/maps/contrib/118374013317604015266/reviews?hl=fr',
        photoURI:
          'https://lh3.googleusercontent.com/a/ACg8ocKcCZgEMg2-sntsXjc1JvC4S6y5buK4Q0pIL-p3PsTT5RKwnQ=s64-c-rp-mo-br100',
      },
      publishMonth: '2026-08',
      rating: 5,
      text: 'Très professionnel, travail de qualité et excellent service. Je recommande vivement !',
    },
  ];

  function getLocale() {
    return document.documentElement.lang || navigator.language || 'fr-FR';
  }

  function formatPublishMonth(value) {
    const [year, month] = String(value).split('-').map(Number);
    if (!year || !month) return '';

    return new Intl.DateTimeFormat(getLocale(), {
      month: 'long',
      timeZone: 'UTC',
      year: 'numeric',
    }).format(new Date(Date.UTC(year, month - 1, 1)));
  }

  class NCGoogleRating extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.dataset.googleState = 'static';
    }
  }

  class NCGoogleReviews extends HTMLElement {
    #abortController;
    #cards = [];
    #currentIndex = 0;

    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.#abortController = new AbortController();

      this.#bindControls();

      const track = this.querySelector('[data-google-reviews-track]');
      if (!track) return;

      const placeUrl = this.querySelector('a[data-google-link]')?.href;
      this.#renderReviews(track, curatedGoogleReviews, placeUrl);
      this.dataset.googleState = 'static';
    }

    disconnectedCallback() {
      this.#abortController?.abort();
    }

    #bindControls() {
      const signal = this.#abortController.signal;
      const dots = this.querySelector('[data-google-reviews-dots]');

      dots?.addEventListener(
        'click',
        (event) => {
          const button = event.target.closest('[data-google-review-dot]');
          if (!button || !dots.contains(button)) return;

          const index = Number(button.dataset.reviewIndex);
          if (Number.isInteger(index)) this.#showSlide(index);
        },
        { signal },
      );

      dots?.addEventListener('keydown', (event) => this.#handleDotKeydown(event), { signal });
    }

    #renderReviews(track, reviews, placeUrl) {
      const fragment = document.createDocumentFragment();
      const total = reviews.length;

      for (const [index, review] of reviews.entries()) {
        fragment.append(this.#createReviewCard(review, index, total, placeUrl));
      }

      track.replaceChildren(fragment);
      track.hidden = false;
      track.setAttribute('aria-busy', 'false');
      this.querySelector('[data-google-reviews-fallback]')?.setAttribute('hidden', '');

      this.#cards = Array.from(track.querySelectorAll('[data-google-review-slide]'));
      const navigation = this.querySelector('[data-google-reviews-navigation]');

      if (this.#cards.length > 1) {
        this.#renderDots(track.id);
        navigation?.removeAttribute('hidden');
      }

      this.#showSlide(0);
    }

    #createReviewCard(review, index, total, placeUrl) {
      const locale = getLocale().toLowerCase();
      const isFrench = locale.startsWith('fr');
      const card = document.createElement('article');
      const header = document.createElement('header');
      const avatar = document.createElement('span');
      const authorGroup = document.createElement('span');
      const attribution = review.authorAttribution;
      const authorName = attribution?.displayName || (isFrench ? 'Client Google' : 'Google customer');
      const authorElement = attribution?.uri ? document.createElement('a') : document.createElement('span');
      const authorMeta = document.createElement('span');
      const date = document.createElement('span');
      const stars = document.createElement('span');
      const quote = document.createElement('blockquote');
      const quoteText = document.createElement('p');
      const reviewLink = document.createElement('a');
      const reviewRating = Number(review.rating);
      const roundedRating = Number.isFinite(reviewRating) ? Math.round(reviewRating) : 5;

      card.className = 'nc-google-reviews__card';
      card.dataset.googleReviewSlide = '';
      card.setAttribute('role', 'group');
      card.setAttribute('aria-roledescription', isFrench ? 'avis' : 'review');
      card.setAttribute('aria-label', isFrench ? `Avis ${index + 1} sur ${total}` : `Review ${index + 1} of ${total}`);
      card.hidden = index !== 0;

      header.className = 'nc-google-reviews__card-header';
      avatar.className = 'nc-google-reviews__avatar';
      avatar.textContent = authorName.trim().charAt(0).toUpperCase();

      if (attribution?.photoURI) {
        const photo = document.createElement('img');
        photo.src = attribution.photoURI;
        photo.alt = '';
        photo.width = 40;
        photo.height = 40;
        photo.loading = 'lazy';
        photo.addEventListener('error', () => photo.remove(), {
          once: true,
          signal: this.#abortController.signal,
        });
        avatar.append(photo);
      }

      authorGroup.className = 'nc-google-reviews__author';
      authorElement.className = 'nc-google-reviews__author-name';
      authorElement.textContent = authorName;

      if (attribution?.uri) {
        authorElement.href = attribution.uri;
        authorElement.target = '_blank';
        authorElement.rel = 'noopener noreferrer';
      }

      date.className = 'nc-google-reviews__date';
      date.textContent = formatPublishMonth(review.publishMonth) || review.relativePublishTimeDescription || '';

      authorMeta.className = 'nc-google-reviews__author-meta';
      if (review.isLocalGuide) {
        const localGuide = document.createElement('span');
        localGuide.className = 'nc-google-reviews__local-guide';
        localGuide.textContent = 'Local Guide';
        authorMeta.append(localGuide);
      }
      authorMeta.append(date);
      authorGroup.append(authorElement, authorMeta);

      stars.className = 'nc-google-reviews__card-stars';
      stars.textContent = '★'.repeat(Math.max(1, Math.min(5, roundedRating)));
      stars.setAttribute(
        'aria-label',
        isFrench ? `${roundedRating} étoiles sur 5` : `${roundedRating} stars out of 5`,
      );

      header.append(avatar, authorGroup, stars);

      quote.className = 'nc-google-reviews__quote';
      quoteText.textContent = review.text.trim();
      quote.append(quoteText);

      reviewLink.className = 'nc-google-reviews__card-link';
      reviewLink.href = review.googleMapsURI || placeUrl || '#';
      reviewLink.target = '_blank';
      reviewLink.rel = 'noopener noreferrer';
      reviewLink.textContent = this.dataset.reviewLinkLabel || 'Google';

      card.append(header, quote, reviewLink);
      return card;
    }

    #renderDots(trackId) {
      const dots = this.querySelector('[data-google-reviews-dots]');
      if (!dots) return;

      const locale = getLocale().toLowerCase();
      const separator = locale.startsWith('fr') ? 'sur' : 'of';
      const label = this.dataset.dotLabel || (locale.startsWith('fr') ? "Afficher l'avis" : 'Show review');
      const fragment = document.createDocumentFragment();

      for (const index of this.#cards.keys()) {
        const button = document.createElement('button');
        button.className = 'nc-google-reviews__dot';
        button.type = 'button';
        button.dataset.googleReviewDot = '';
        button.dataset.reviewIndex = String(index);
        button.setAttribute('aria-label', `${label} ${index + 1} ${separator} ${this.#cards.length}`);
        button.setAttribute('aria-controls', trackId);
        button.tabIndex = -1;
        fragment.append(button);
      }

      dots.replaceChildren(fragment);
    }

    #handleDotKeydown(event) {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

      const buttons = Array.from(this.querySelectorAll('[data-google-review-dot]'));
      if (!buttons.length) return;

      event.preventDefault();
      let nextIndex = this.#currentIndex;

      if (event.key === 'ArrowLeft') nextIndex = (this.#currentIndex - 1 + buttons.length) % buttons.length;
      if (event.key === 'ArrowRight') nextIndex = (this.#currentIndex + 1) % buttons.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = buttons.length - 1;

      this.#showSlide(nextIndex);
      buttons[nextIndex]?.focus();
    }

    #showSlide(index) {
      this.#currentIndex = index;

      for (const [cardIndex, card] of this.#cards.entries()) {
        const isActive = cardIndex === index;
        card.hidden = !isActive;
        card.setAttribute('aria-hidden', String(!isActive));
        card.classList.toggle('is-active', isActive);
      }

      for (const [dotIndex, dot] of this.querySelectorAll('[data-google-review-dot]').entries()) {
        const isActive = dotIndex === index;
        if (isActive) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
        dot.tabIndex = isActive ? 0 : -1;
      }

      const status = this.querySelector('[data-google-reviews-status]');
      if (status) status.textContent = `${index + 1} / ${this.#cards.length}`;
    }
  }

  if (!customElements.get('nc-google-rating')) {
    customElements.define('nc-google-rating', NCGoogleRating);
  }

  if (!customElements.get('nc-google-reviews')) {
    customElements.define('nc-google-reviews', NCGoogleReviews);
  }
})();
